var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAa = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 37 39",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6909_282451)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0.259766,
  y: 1.21826,
  width: 36.5486,
  height: 36.5486,
  fill: "#FFCC01"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.7371 27.7114H27.3373V24.2746H22.7685L21.159 27.7114H17.6884L26.0944 9.83907H30.7371V27.7114ZM27.3186 21.0216V14.6263L24.3223 21.0216H27.3186ZM17.6173 27.7115H14.1821V24.2746H9.64948L8.04159 27.7115H4.5332L12.9761 9.83911H17.6173V27.7115ZM14.1659 21.0216V14.6263L11.1672 21.0216H14.1659Z",
  fill: "#1D1D1D"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6909_282451"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36.5486,
  height: 38.9852,
  fill: "white",
  transform: "translate(0.259766)"
})))));
export { SvgAa as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/src/client/assets_seller/partners/aa.svg", import.meta.url).toString();